__turbopack_context__.v({
  "loading": "skeleton-module__yM3A9W__loading",
  "skeleton": "skeleton-module__yM3A9W__skeleton",
});
